import { NavLink, Outlet } from 'react-router-dom';
import {
  ChartBarIcon,
  DocumentTextIcon,
  InboxStackIcon,
  PaperAirplaneIcon,
  ShieldCheckIcon,
  Squares2X2Icon,
} from '@heroicons/react/24/outline';
import { focusRing } from './outreachUtils';

const tabs = [
  { name: 'Overview', to: '', end: true, icon: Squares2X2Icon },
  { name: 'Campaigns', to: 'campaigns', icon: PaperAirplaneIcon },
  { name: 'Templates', to: 'templates', icon: DocumentTextIcon },
  { name: 'Queue', to: 'queue', icon: InboxStackIcon },
  { name: 'Deliveries', to: 'deliveries', icon: ChartBarIcon },
  { name: 'Preferences & suppressions', to: 'preferences', icon: ShieldCheckIcon },
];

export default function OutreachLayout() {
  return (
    <div className="space-y-5">
      <div className="rounded-xl border border-slate-700 bg-slate-900 px-5 py-5 text-white shadow-sm">
        <p className="text-xs font-semibold uppercase tracking-[0.18em] text-blue-300">
          Founder operations
        </p>
        <h3 className="mt-1 text-2xl font-bold">Lifecycle Outreach</h3>
        <p className="mt-1 max-w-3xl text-sm leading-6 text-slate-300">
          Review eligibility, campaign safety, templates, and delivery evidence. Recipient
          preferences and provider suppressions remain authoritative.
        </p>
      </div>

      <nav
        aria-label="Outreach sections"
        className="flex gap-1 overflow-x-auto rounded-xl border border-gray-200 bg-white p-2 shadow-sm"
      >
        {tabs.map((tab) => (
          <NavLink
            key={tab.name}
            to={tab.to}
            end={tab.end}
            className={({ isActive }) =>
              `inline-flex min-h-[44px] items-center gap-2 whitespace-nowrap rounded-lg px-3 py-2 text-sm font-medium transition-colors ${focusRing} ${
                isActive
                  ? 'bg-slate-900 text-white shadow-sm'
                  : 'text-gray-600 hover:bg-gray-100 hover:text-gray-900'
              }`
            }
          >
            <tab.icon className="h-4 w-4 flex-none" />
            {tab.name}
          </NavLink>
        ))}
      </nav>

      <Outlet />
    </div>
  );
}
